<template>
    <div class="registerContainer">
        <div class="banner">
            <img src="../../../assets/img/logo.png" alt/>
        </div>
        <div style="margin: auto;width: 100%;">
            <div class="loginBox">
                <el-form ref="form" :model="form" label-width="100px" class="ms-content">
                    <div
                        style="width: 10px;height:10px;border-top: 2px solid white;border-left: 2px solid white;float: left;position: relative;border-top-left-radius: 4px;">
                        &nbsp;
                    </div>
                    <div
                        style="width: 10px;height:10px;border-top: 2px solid white;border-right: 2px solid white;float: right;position: relative;border-top-right-radius: 4px;">
                        &nbsp;
                    </div>
                    <div class="loginHeader">
                        <span>渠道认证管理系统</span>
                    </div>
                    <div style="height: 1px;background-color: white;opacity: 0.8;width: 100%;margin-bottom: 50px;">
                        <hr style="border:1px solid rebeccapurple;width: 20px;margin: 0 auto;"/>
                    </div>
                    <el-form-item label="账号昵称" style="margin-right: 20px;">
                        <el-input
                            type="text"
                            placeholder="输入公司简称"
                            v-model="form.userName">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="密码" style="margin-right: 20px;">
                        <el-input
                            type="password"
                            placeholder="数字加字母"
                            v-model="form.newPwd">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="密码确认" style="margin-right: 20px;">
                        <el-input type="password" v-model="form.confirmNewPwd"></el-input>
                    </el-form-item>
                    <!--        <el-form-item label="二级密码">-->
                    <!--          <el-input type="password" v-model="form.newSecondPwd"></el-input>-->
                    <!--        </el-form-item>-->
                    <!--        <el-form-item label="二级密码确认">-->
                    <!--          <el-input type="password" v-model="form.confirmNewSecondPwd"></el-input>-->
                    <!--        </el-form-item>-->

                    <div
                        style="width: 10px;height:10px;border-bottom: 2px solid white;border-left: 2px solid white;float: left;position: relative;border-bottom-left-radius: 4px;margin: 118px 0;">
                        &nbsp;
                    </div>
                    <div
                        style="width: 10px;height:10px;border-bottom: 2px solid white;border-right: 2px solid white;float: right;position: relative;border-bottom-right-radius: 4px;margin: 118px -1px;">
                        &nbsp;
                    </div>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="gotoLoginPage">返 回</el-button>
                    <el-button type="primary" @click="saveCreate">确 定</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            fixedRoleId: "16638f44bcad4cf09c025a7d627f5ac1",
            form: {
                id: "",
                userName: "",
                pwd: "",
                newPwd: "",
                confirmNewPwd: "",
                secondPwd: "",
                newSecondPwd: "1",
                confirmNewSecondPwd: "1"
            }
        };
    },
    created() {
    },
    methods: {
        saveCreate() {
            let modes = 0;
            if (/\d/.test(this.form.newPwd))
                modes++;
            if (/[a-z]/.test(this.form.newPwd))
                modes++;
            if (/[A-Z]/.test(this.form.newPwd))
                modes++;
            if (/\W/.test(this.form.newPwd))
                modes++;

            if (this.form.pwd.length < 6 && modes < 2) {
                this.$message.warning(`密码请输入字母加数字且大于等于6位`);
                return;
            }

            if (
                this.form.confirmNewPwd !== this.form.newPwd ||
                this.form.confirmNewSecondPwd !== this.form.newSecondPwd
            ) {
                this.$message.warning(`两次输入的密码不匹配`);
                return;
            }


            this.$axios({
                method: "post",
                url: "/api/user/create",
                withCredentials: true,
                data: this.$qs.stringify({
                    userName: this.form.userName,
                    pwd: this.form.newPwd,
                    secondPwd: this.form.newSecondPwd
                })
            })
                .then(response => {
                    //这里使用了ES6的语法
                    if (response.data.code === 1) {
                        this.createVisible = false;
                        this.$message.success(`账号创建成功!`);
                        // this.giveRole(response.data.data);
                    } else {
                        this.createVisible = false;
                        this.$message.warning(response.data.message);
                    }
                })
                .catch(error => {
                    this.createVisible = false;
                    this.$message.error(`创建失败`);
                    console.log(error); //请求失败返回的数据
                })
                .finally(() => {
                    this.$router.push({path: "/work/login"});
                });
        },
        // giveRole(userId){
        //     var roles = this.fixedRoleId;
        //     console.log(userId);
        //     console.log(roles);
        //     this.$axios({
        //         method:'get',
        //         url:'/api/user/authorize',
        //         withCredentials:true,
        //         type:'json',
        //         params: {
        //             userId: userId,
        //             roles: roles
        //         }
        //     }).then((response) =>{          //这里使用了ES6的语法
        //         if(response.data.code == 1){
        //             this.$message.success(`分权成功，账号创建完毕`);
        //         }else{
        //             this.$message.warning(response.data.message);
        //         }
        //     }).catch((error) =>{
        //         this.$message.error(`分权失败，请联系管理员分配权限`);
        //         console.log(error)       //请求失败返回的数据
        //     }).finally(()=>{
        //     })
        // },
        gotoLoginPage() {
            this.$router.push({path: "/work/login"});
        }
    }
};
</script>
<style type="text/css">
.registerContainer .el-form-item__label {
    color: white;
}
</style>
<style type="text/css" scoped>
.registerContainer {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    /*flex-wrap: nowrap;*/
    /*justify-content: right;*/
    background-image: url(../../../assets/img/login-bg2.jpg);
    background-size: cover;
}

.loginBox {
    margin: 100px auto;
    background: rgba(0, 0, 0, .4);
    border-radius: 4px;
    height: 400px;
    width: 330px;
}

@media screen and (max-width: 750px) {
    .loginBox {
        float: initial;
        margin: auto;
        background: rgba(0, 0, 0, .4);
        border-radius: 4px;
        width: 330px;
        height: 400px;
    }
}

.consoleInputBox {
    margin: 16px auto;
}

.consoleInputBox input {
    background: transparent;
    border-color: #555;
    color: white;
}

.consoleButtonBox .btn {
    width: 100%;
}

.dialog-footer {
    display: -webkit-box;
    text-align: right;
    -webkit-box-pack: end;
    justify-content: end;
    margin-right: 20px;
}

.banner {
    display: flex;
    justify-content: flex-start;
    float: left;
    position: absolute;
    margin: 20px 20px;
}

.loginHeader {
    text-align: center;
    color: white;
    font-size: 20px;
    padding: 20px;
    font-weight: bold;
}
</style>